<script>
    import { onMount } from 'svelte';
    import dbData from "../../Stores/utilityDBStore.js";
    import { recordingDateForDisplay } from '../../scripts/alfxCorrelation.js';
    import { correlationsByRecordingDate } from '../../scripts/alfxLocation.js';
    import { updateOverlays } from '../../scripts/viewMap.js';
    import WPNSelector from "../Misc/WPNSelector.svelte";
    import CorrelationGraph from './CorrelationGraph.svelte';
    import Feedback from "../Details/Feedback.svelte";
    import Base64AudioPlayer from './Base64AudioPlayer.svelte';

    export let locationItem;
    let corrItemsByRecDate;
    let recordingDates;
    let selectedRecDate;

    // ALFX_TODO: Work out audio of sync recordings (URLs are stored where?)

    onMount(() => {
        updateOverlays([locationItem], 'SoundPath');
        // const paths = Object.values(locationItem?.['hydrant_paths'] ?? [])
        // showPathOverlays(paths);
        corrItemsByRecDate = correlationsByRecordingDate(locationItem, $dbData.alfx_data);
        const recordingDatesAsText = Object.keys(corrItemsByRecDate)
            .filter(key => Number.isFinite(Number(key)))
            .sort((a, b) => Number(b) - Number(a));
        recordingDates = recordingDatesAsText.map(x => Number(x));
        selectedRecDate = recordingDates[0];
        console.log("1st recording date: ", selectedRecDate);
    });

    function changeRecordingDate(event) {
        selectedRecDate = event.detail.value;
    }

</script>

{#if corrItemsByRecDate && recordingDates && selectedRecDate}
<div class="detail-section">
    <div class="split-title-buttons">
        <div class="detail-section-title split-view-title">Location Analysis</div>
        <label id="days-label" for="days1">Analysis Date:</label>
        <WPNSelector
            styleOverride="margin-top: -6px; margin-left: 2px;"
            selectorOptions={ recordingDates.map(x => ({value: x, title: recordingDateForDisplay(x) })) }
            selectorName="days1"
            selected={selectedRecDate}
            on:selector-changed={changeRecordingDate}
        />
    </div>
    <!-- <Base64AudioPlayer audioName={"H61"} audioUrl={'https://sveltejs.github.io/assets/music/strauss.mp3'}/>
    <Base64AudioPlayer audioName={"H64"} audioUrl={'https://sveltejs.github.io/assets/music/strauss.mp3'}/> -->
    {#each corrItemsByRecDate[selectedRecDate] as corrItem}
        <CorrelationGraph {corrItem} {locationItem} />
    {/each}
    <Feedback {locationItem} />
    <!-- {#each correlationHydrantItems(history, daysAgo, $dbData.all) as hydrant}
        <AudioPlayer audioInfo={audioInfoForItem(hydrant, "Sync", daysAgo, $dbData.wpn_id)} />
    {/each} -->
</div>
{/if}

<style>
    #days-label {
        margin-top: 2px;
        margin-right: 4px;
    }
</style>